import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsPfdodCheckMixin extends Vue {
  get hasVacanciesModule() {
    return !!this.$store.getters.hasApiModuleVacancies;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/vacanciesModule.ts